import { noticeTypes } from 'config/types';
import { computed } from 'mobx';
import { groupByDate, sortByDate } from 'helpers/firebaseDataHelpers';

const groupAndOrderByTenancies = (items, getField = (i, field) => i[field]) => {
  const byUidMap = items.reduce((acc, item) => {
    const tenancyUid = getField(item, 'tenancyUid');
    if (!acc[tenancyUid]) {
      acc[tenancyUid] = [item];
      return acc;
    }

    acc[tenancyUid].push(item);
    return acc;
  }, {});

  const getDateField = (i) => getField(i, 'dateUpdated');
  const itemsByDateArray = Object.keys(byUidMap).map((key) => {
    const itemsForUid = byUidMap[key].sort(sortByDate(-1, getDateField));
    const groupedItemsByDate = Object.values(
      groupByDate(itemsForUid, getDateField)
    );

    return {
      tenancyUid: key,
      data: groupedItemsByDate,
    };
  });

  return itemsByDateArray.sort(sortByDate(-1, (i) => i.date));
};

class NoticesMapper {
  constructor(noticesCollection) {
    this.collection_ = noticesCollection;
  }

  get sortedData() {
    // console.log(this.collection_.data);
    // this.collection_.data?.forEach(())
    return this.collection_.data?.sort((doc1, doc2) => {
      try {
        return doc1.data.dateUpdated?.toDate() > doc2.data.dateUpdated?.toDate()
          ? -1
          : 1;
      } catch (e) {
        console.log('..........................errr');
        console.log(doc1.data.dateCreated, doc2.data.dateCreated);
        console.log(doc1.data, doc2.data);
        console.error(e);
        return -1;
      }
    });
  }

  get adminData() {
    return this.sortedData?.filter(
      ({ data: { noticeType } }) =>
        noticeType === noticeTypes.ADMIN || noticeType === noticeTypes.TENANCY
    );
  }

  get paymentsData() {
    return this.sortedData?.filter(
      ({ data: { noticeType } }) => noticeType === noticeTypes.PAYMENTS
    );
  }

  get tenancyData() {
    return this.sortedData?.filter(
      ({ data: { noticeType } }) => noticeType === noticeTypes.TENANCY
    );
  }

  get messagingData() {
    return this.sortedData?.filter(
      ({ data: { noticeType } }) => noticeType === noticeTypes.MESSAGING
    );
  }

  get messagingDataByTenancy() {
    return this.messagingData
      ? groupAndOrderByTenancies(
          this.messagingData,
          (i, field) => i.data[field]
        )
      : [];
  }
}

NoticesMapper.annotations = {
  sortedData: computed,
  adminData: computed,
  paymentsData: computed,
  messagingData: computed,
  messagingDataByTenancy: computed,
};

export default NoticesMapper;
